import { render, staticRenderFns } from "./BaseConfig.vue?vue&type=template&id=43ca9e78&scoped=true&"
import script from "./BaseConfig.vue?vue&type=script&lang=js&"
export * from "./BaseConfig.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfig.vue?vue&type=style&index=0&id=43ca9e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ca9e78",
  null
  
)

export default component.exports